import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));

const AdminUsersTable = withLazyFallback(
  () => import('components/admin/pages/Users/AdminUsersTable')
);
const AdminUserLogs = withLazyFallback(() => import('components/admin/pages/Users/Logs'));

const AdminUserOverview = withLazyFallback(() => import('components/admin/pages/Users/Overview'));
const AdminUserSessions = withLazyFallback(() => import('components/admin/pages/Users/Sessions'));
const AdminUserUser = withLazyFallback(() => import('components/admin/pages/Users/User'));

const ADMIN_USERS = [
  {
    path: 'users',
    element: <AdminUsersTable />,
    handle: { title: 'Admin users' },
    children: [
      {
        path: ':id',
        element: <AdminUserUser />,
        children: [
          { path: '', element: <AdminUserOverview />, handle: { title: 'Overview' } },
          { path: 'logs', element: <AdminUserLogs />, handle: { title: 'Logs' } },
          { path: 'sessions', element: <AdminUserSessions />, handle: { title: 'Sessions' } },
          { path: '*', element: <NotFound /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];
export default ADMIN_USERS;
